import { useState } from 'react'
import type { QuestionProps } from '../eform.types'

export default function DropdownField({ question, value, onChange, error }: QuestionProps) {
  const strValue = Array.isArray(value) ? value[0] ?? '' : value
  const [otherText, setOtherText] = useState('')

  const isOther = strValue.startsWith('other:')

  function handleOtherText(text: string) {
    setOtherText(text)
    onChange('other:' + text)
  }

  return (
    <div className="space-y-2">
      <select
        value={isOther ? '__other__' : strValue}
        onChange={(e) => {
          if (e.target.value === '__other__') {
            onChange('other:' + otherText)
          } else {
            onChange(e.target.value)
          }
        }}
        className={`w-full rounded-lg border px-4 py-3 text-sm bg-white transition-colors focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary ${
          error ? 'border-red-300' : 'border-slate-200'
        }`}
      >
        <option value="">Select an option</option>
        {question.options.map((opt) => (
          <option key={opt.id} value={String(opt.id)}>
            {opt.text}
          </option>
        ))}
        {question.addOther && <option value="__other__">Other</option>}
      </select>
      {isOther && (
        <input
          type="text"
          value={otherText}
          onChange={(e) => handleOtherText(e.target.value)}
          placeholder="Please specify"
          className="w-full rounded-lg border border-slate-200 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary"
          autoFocus
        />
      )}
      {error && <p className="text-sm text-red-500 mt-1">{error}</p>}
    </div>
  )
}
